'use strict';

var
  Backbone = require('backbone'),
  LinkProjectModel = require('./LinkProjectModel'),

  LinkProjectsCollection = Backbone.Collection.extend({

    model: LinkProjectModel

  }, {
    STATE: LinkProjectModel.STATE
  });

module.exports = LinkProjectsCollection;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/LinkProjectsCollection.js